<!-- This wrapper shows the background without any animations on it-->
<div class="backGroundWrapper">

  <!--
  We need the fadeIn animation on the container
  to prevent the slideOutLeft animation from running at the initial render.
  -->
  <div class="contentWrapper" @fadeIn>

    <!-- Keep the groups on screen to store the scrollPosition? -->
    <tun-music-channel-groups-view
      [@viewPosition]="mainViewPosition$ | async"
      class="fullContainer">
    </tun-music-channel-groups-view>

    @if ((showDetailsForMusicChannel$ | async) != null) {
      <tun-music-channel-detail-view
        @slideInRight
        class="fullContainer"
        >
      </tun-music-channel-detail-view>
    }

    @if (!(accessToMusicChannels$ | async)) {
      <tun-access-right-overlay-view
        class="fullContainer"
        [message]="'accessRight.screen.musicChannels' | translate">
      </tun-access-right-overlay-view>
    }

  </div>


</div>
